import React, { useEffect, useState } from "react";
import PersonAddAlt1Icon from "@mui/icons-material/PersonAddAlt1";
import { useNavigate } from "react-router-dom";

import { useForm, Controller } from "react-hook-form";
import Select from "react-select";
import Topbar from "../../../Component/Topbar/Topbar";
import { Table } from "../../../Component/Table/Table";
import { edit, search, view } from "../../../assets/img";
import DateRange from "../../../Component/DateRange/DateRange";
import SelectBox from "../../../Component/SelectBox";
import { get, post } from "../../redux/api/ApiHandler";
import moment from "moment";
import { URLS } from "../../redux/api/Constants";
const DeliveryTable = () => {
  const navigate = useNavigate();

  const [list, setList] = useState([]);
  const [page, setPage] = useState(1);
  const [superAdmin, setSuperAdmin] = useState();
  const [pagination, setPagination] = useState("");
  const [selected, setSelected] = useState(null);
  const [status, setStatus] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  const [regionOptions, setRegionOptions] = useState([]);
  const [fromDates, setFromDates] = useState(null);
  const [toDates, setToDates] = useState(null);

  const role = localStorage.getItem("role");



  const ticketList = async (search, selected, fromDate, toDate) => {
    setSearchValue(search);
    setFromDates(fromDate);
    setToDates(toDate);

    let payload = {
      search: search,
      pagination: page,
      region_id: selected?.value,
      type: 2,
      current_status: role == "Inventory" ? 10 : role == "Technical" ? 14 : "",
      from_date: fromDate ? moment(fromDate).format("DD-MM-YYYY") : "",
      to_date: toDate ? moment(toDate).format("DD-MM-YYYY") : "",
    };
    let res = await post(URLS.TICKET_LIST, payload)
    if (role == "Technical") {
      if (res?.status == "success") {
        const filteredTicketes = res?.lists?.filter(ticket => {
          const details = ticket?.ticket_details;

          if (!details || details.length === 0) return false;

          const lastDetail = details[details.length - 1];

          return lastDetail?.moved_to === 1;
        });

        setList(filteredTicketes);
        setPagination(res?.pagination_meta);
      }

    }
    if (role == "Inventory") {
      if (res?.status == "success") {
        setList(res?.lists)
        setPagination(res?.pagination_meta)
      }
    }
  }




  const regionList = async () => {
    let res = await get(URLS.REGIONLIST);
    if (res?.status === "success" && Array.isArray(res?.roles)) {
      // 🔹 Convert API data to Select options
      const options = res?.roles.map((region) => ({
        value: region?.id,
        label: region?.name,
      }));
      setRegionOptions(options);

    }
  }

  useEffect(() => {
    ticketList()
    regionList()
  }, []);

  const columns = React.useMemo(
    () => [
      {
        Header: "S.No",
        accessor: "",
        Cell: ({ value, row }) => {
          return <p>{row.index + 1}</p>;
        },
      },

      {
        Header: "Regional Ticket ID ",
        accessor: "code",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap ">{value}</p>;
        },
      },
      {
        Header: "Region",
        accessor: "region",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap ">{value}</p>;
        },
      },
      {
        Header: "Regional Manager",
        accessor: "regional_manager",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap ">{value}</p>;
        },
      },
      {
        Header: "Service Engineer",
        accessor: "service_engineer",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap ">{value}</p>;
        },
      },

      {
        Header: "Customer ID",
        accessor: "customer",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap ">{value?.code}</p>;
        },
      },
      {
        Header: "Customer Name",
        accessor: "customer.name",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap ">{value}</p>;
        },
      },
      {
        Header: "Created by",
        accessor: "created_by",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap ">{value?.name}</p>;
        },
      },

      {
        Header: "Date",
        accessor: "opened_at",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap ">{moment(value).format("DD-MM-YYYY")}</p>;
        },
      },
      // {
      //   Header: role == "Inventory" ? "Tracking ID" : "Fault Type",
      //   accessor: role == "Inventory" ? "trackin_id" : "faultType",
      //   Cell: ({ value, row }) => {
      //     return <p className="text-nowrap d-flex ac-jc">{value ? value : '-'}</p>;
      //   },
      // },
      {
        Header: "Request Status",
        accessor: "current_status",
        Cell: ({ value, row }) => {
          return (
            <div className="d-flex ac-jc">
              {role == "Inventory" ? (
                <button
                  // onClick={() => handleStatus(row)}
                  className="delivered_btn f1 fs-xs-12 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-15 fs-xxl-16"
                >
                  Delivered
                </button>
              ) : (
                <button
                  // onClick={() => handleStatus(row)}
                  className="technical_btn f1 fs-xs-12 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-15 fs-xxl-16"
                  style={{
                    backgroundColor: "#323691",
                  }}
                >
                  Super Admin
                </button>
              )}
            </div>
          );
        },
      },
      {
        Header: "Action",
        accessor: "",
        Cell: ({ value, row }) => {
          const status = row.original.status;
          return (
            <div className="d-flex ac-jc mt-2 gap-3">
              <button
                onClick={() => {
                  navigate("/delivery-view", {
                    state: { type: "view", id: row?.original?.id, tickType: "Dispatch" }
                    // state: {
                    //   type: "view",
                    //   data: {
                    //     ticketType: "Delivered",
                    //     trackingId: "ICIPL234",
                    //   },
                    // },
                  });
                }}
                className="cust-btn "
              >
                <img src={view} alt="" className="editor-btn" />
              </button>

              {/* <button
                onClick={() => {
                  navigate("/view-inventory", { state: { type: "edit" } });
                }}
                className="cust-btn "
              >
                <img src={edit} alt="" className="editor-btn" />
              </button> */}
            </div>
          );
        },
      },
    ],
    []
  );
  return (
    <>
      <Topbar header={"Inventory"} />
      <div className="container_fluit1">
        <div className="d-flex ac-js">
          <h4 className="f3 fs-sm-15 fs-md-19 fs-lg-20 fs-xl-22 fs-xxl-24">
            Total New Ticket :  {list?.length}
          </h4>
        </div>
        <div className="d-flex ac-je gap-4">
          <DateRange />
          <div className="col-md-2">
            <SelectBox options={regionOptions} selected={selected} setSelected={(val) => ticketList(searchValue, val)} />
          </div>

          <div className="search-input col-md-3 d-flex ac-jb my-4">
            <input value={searchValue} onChange={(e) => ticketList(e.target.value, selected)}
              type="text"
              placeholder="Search "
              className="search-field f2 fs-sm-13 fs-md-15 fs-lg-16 fs-xl-18 fs-xxl-20"
            />
            <img src={search} className="search" />
          </div>
        </div>
        <Table
          columns={columns}
          setPageno={setPage}
          pagecount={pagination}
          data={list}
          show={false}
        />
      </div>
    </>
  );
};

export default DeliveryTable;
